module.exports = __webpack_public_path__ + "img/case-logo-19.86d7d082.png";